import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { ACCESS_SERVICE_TOKEN } from '../access-service-provider-token';
import { AccessService } from '../access/access.service';
import { AccessState } from '../access/access.state';
import { SessionIdInterceptor } from './session-id.interceptor';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export let CoreAccessModule = /*#__PURE__*/(() => {
  class CoreAccessModule {
    static forRoot() {
      return {
        ngModule: CoreAccessModule
      };
    }
    static {
      this.ɵfac = function CoreAccessModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreAccessModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreAccessModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: SessionIdInterceptor
        }, {
          provide: 'accessService',
          useClass: AccessService
        },
        // use this token to fix circular dependencies regarding AccessService
        {
          provide: ACCESS_SERVICE_TOKEN,
          useClass: AccessService
        }
        // AccessService cannot be auto-injected into AccessServiceProvider.
        // likely the problem is introduced by the webpack module replacement.
        // use a provider with factory passing AccessService correctly.
        ],
        imports: [NgxsModule.forFeature([AccessState])]
      });
    }
  }
  return CoreAccessModule;
})();